import { BASE_API_LIVE_SWAP } from 'config/constants/endpoints'
import fetchHelper from 'helpers/FetchHelper'

function checkStakeNft(nftId: string, cbs?: any, cbe?: any) {
  try {
    fetchHelper
      .fetch(`${BASE_API_LIVE_SWAP}/nft-stake/check-stake-nft/${nftId}`, {
        method: 'GET',
      })
      .then(([resp, status]: any) => {
        if (status === 200) {
          if (cbs) cbs(resp?.data)
        } else if (cbe) cbe(resp)
      })
  } catch (error) {
    console.error('checkStakeNft', error)
  }

  return null
}

export default checkStakeNft
